import React from 'react';
import {useField} from 'formik';
import {t} from 'ttag';
import {Input} from '../../../../../../components/form/form.jsx';
import * as Title from '../../../../../../components/title/title.jsx';

const Fullname = () => {
  const [field, meta, helpers] = useField('fullname');

  const {error, touched} = meta;
  const {setValue} = helpers;

  const isValid = !(error && touched);

  return (
    <>
      <Title.H3 style={{marginBottom: 8}}>{t`Name`}</Title.H3>

      <Input
        {...field}
        placeholder={t`Name`}
        isValid={isValid}
        style={{marginBottom: 16}}
        onChange={setValue}
      />
    </>
  );
};

export default Fullname;
